(function(){
    'use strict';

    angular
        .module('elogbooks.user.spillages')
        .controller('UserSpillageListController', UserSpillageListController);

    UserSpillageListController.$inject = [
        '$stateParams',
        '$state',
        'spillageCollectionResponse',
        'serviceProviderCollectionResponse',
        'operativeCollectionResponse',
        '$translate',
        'siteCollectionResponse',
        'selectedSiteResponse',
        'spillageTypeCollectionResponse'
    ];

    function UserSpillageListController(
        $stateParams,
        $state,
        spillageCollectionResponse,
        serviceProviderCollectionResponse,
        operativeCollectionResponse,
        $translate,
        siteCollectionResponse,
        selectedSiteResponse,
        spillageTypeCollectionResponse
    ) {
        var vm = this;
        vm.search = search;
        vm.spillageCollectionResponse = spillageCollectionResponse;
        vm.spillages = spillageCollectionResponse.spillages;
        vm.stateParams = $stateParams;
        vm.loadedCollections = [serviceProviderCollectionResponse];

        vm.stateParams = $stateParams;
        vm.criteria = {};

        var options = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('YES'),
                value: '1'
            },
            {
                title: $translate.instant('NO'),
                value: '0'
            }
        ];

        if (siteCollectionResponse) {
            vm.siteSelect = {
                response : siteCollectionResponse,
                link : siteCollectionResponse.getLink('self'),
                responseKeyPath: 'sites',
                itemValuePath: 'name',
                itemHrefPath: 'id',
                disabled: !!selectedSiteResponse
            };

            if (selectedSiteResponse) {
                vm.siteSelect.cacheItems = [{value:selectedSiteResponse.name, href:selectedSiteResponse.id, object:selectedSiteResponse}];
            }

            vm.criteria.siteIds = {
                type: 'autocompletemulti',
                multiple: true,
                title: 'SITE',
                value: $stateParams.siteIds,
                options: vm.siteSelect ? vm.siteSelect : null,
                param: 'siteIds',
                max: 50,
                isClear: !$stateParams.siteIds || $stateParams.siteIds.length === 0,
                isDisabled: !!selectedSiteResponse
            };
        }

        vm.criteria.locationName = { type: 'text', title: 'FILTER_LOCATION_NAME', value: $stateParams.locationName };

        if (spillageTypeCollectionResponse) {
            vm.spillageTypeSelect = {
                response: spillageTypeCollectionResponse,
                link: spillageTypeCollectionResponse.getLink('self'),
                // Searching reloads from the link, so these keep the same types on offer.
                // searchOwnName stops a parent's name also matching its descendants
                linkParameters: { active: 1, allSites: 1, searchOwnName: 1, limit: 999999 },
                responseKeyPath: 'spillagetypes',
                itemValuePath: 'name',
                itemHrefPath: 'id',
                isHierarchical: true,
                useIndentedHierarchy: true
            };

            vm.criteria.spillageTypes = {
                type: 'autocompletemulti',
                multiple: true,
                title: 'TYPE',
                value: $stateParams.spillageTypes,
                options: vm.spillageTypeSelect,
                param: 'spillageTypes',
                max: 50,
                isClear: !$stateParams.spillageTypes || $stateParams.spillageTypes.length === 0
            };
        }

        vm.criteria.summary = { type: 'text', title: 'SUMMARY', value: $stateParams.summary };
        vm.criteria.description = { type: 'text', title: 'DESCRIPTION', value: $stateParams.description };

        vm.operativeSelect = {
            response: operativeCollectionResponse,
            // Falls back to the endpoint so searching still works if the operatives could not be loaded
            link: operativeCollectionResponse ? operativeCollectionResponse.getLink('self') : '/operatives',
            linkParameters: { permission: 'operative_permission_receive_spillages' },
            responseKeyPath: 'operatives',
            itemValuePath: '_links.user.id',
            itemTitlePath: '_links.user.name'
        };

        vm.criteria.operative = { type: 'jsonselectwidget', title: 'OPERATIVE', value: JSON.parse($stateParams.operative), options: vm.operativeSelect };

        vm.criteria.createdAtStart = { type: 'date', value: $stateParams.createdAtStart, title: 'CREATED_AT_START', maxDependsOn: 'createdAtEnd' };
        vm.criteria.createdAtEnd = { type: 'date', value: $stateParams.createdAtEnd, title: 'CREATED_AT_END', minDependsOn: 'createdAtStart' };
        vm.criteria.accidentOccurred = { type: 'options', title: 'ACCIDENT_OCCURRED', value: $stateParams.accidentOccurred, options: options };
        vm.criteria.assignedToMe = { type: 'options', title: 'ASSIGNED_TO_ME', value: $stateParams.assignedToMe, options: options };

        if (serviceProviderCollectionResponse) {
            vm.serviceProviderSelect = {
                response : serviceProviderCollectionResponse,
                link : serviceProviderCollectionResponse ? serviceProviderCollectionResponse.getLink('self') : null,
                itemValuePath: 'id',
                itemTitlePath: 'name',
                responseKeyPath: 'serviceproviders'
            };

            vm.criteria.serviceProvider = { type: 'jsonselectwidget', title: 'SERVICE_PROVIDER', value: JSON.parse($stateParams.serviceProvider), options: vm.serviceProviderSelect };
        }

        function search(params) {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        }

    }
})();
